// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `* {
  box-sizing: border-box;
  margin: 0;
  padding: 0;
}

body {
  font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;
  line-height: 1.6;
  color: #333;
  background-color: #f5f5f5;
}

.App {
  display: flex;
  flex-direction: column;
  min-height: 100vh;
}

.App-main {
  flex: 1 1;
  background-color: #f5f5f5;
}

a {
  text-decoration: none;
  color: inherit;
}

button {
  cursor: pointer;
  font-family: inherit;
}

input, select, textarea {
  font-family: inherit;
}

h1, h2, h3, h4, h5, h6 {
  margin-bottom: 0.5rem;
  font-weight: 500;
  line-height: 1.2;
}

h1 {
  font-size: 2rem;
}

h2 {
  font-size: 1.75rem;
}

h3 {
  font-size: 1.5rem;
}

h4 {
  font-size: 1.25rem;
}

h5 {
  font-size: 1rem;
}

h6 {
  font-size: 0.875rem;
}

p {
  margin-bottom: 1rem;
}

.container {
  width: 100%;
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 1rem;
}

.text-center {
  text-align: center;
}

.mt-1 {
  margin-top: 0.25rem;
}

.mt-2 {
  margin-top: 0.5rem;
}

.mt-3 {
  margin-top: 1rem;
}

.mt-4 {
  margin-top: 1.5rem;
}

.mt-5 {
  margin-top: 2rem;
}

.mb-1 {
  margin-bottom: 0.25rem;
}

.mb-2 {
  margin-bottom: 0.5rem;
}

.mb-3 {
  margin-bottom: 1rem;
}

.mb-4 {
  margin-bottom: 1.5rem;
}

.mb-5 {
  margin-bottom: 2rem;
}

/* Styles pour les badges de statut */
.status-badge {
  display: inline-block;
  padding: 0.35rem 0.75rem;
  border-radius: 1rem;
  font-size: 0.875rem;
  font-weight: 500;
  text-align: center;
  white-space: nowrap;
  color: #fff;
  margin-right: 0.5rem;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
}

/* Statuts des rendez-vous */
.status-pending {
  background-color: #f0ad4e;
  border: 1px solid #eea236;
}

.status-confirmed {
  background-color: #5bc0de;
  border: 1px solid #46b8da;
}

.status-completed {
  background-color: #5cb85c;
  border: 1px solid #4cae4c;
}

.status-cancelled {
  background-color: #d9534f;
  border: 1px solid #d43f3a;
}

/* Statuts des communications */
.status-not-sent {
  background-color: #777;
  border: 1px solid #666;
}

.status-sending {
  background-color: #f0ad4e;
  border: 1px solid #eea236;
}

.status-sent {
  background-color: #5bc0de;
  border: 1px solid #46b8da;
}

.status-delivered {
  background-color: #5cb85c;
  border: 1px solid #4cae4c;
}

.status-failed {
  background-color: #d9534f;
  border: 1px solid #d43f3a;
}

.status-opened, .status-clicked {
  background-color: #5cb85c;
  border: 1px solid #4cae4c;
}

.status-bounced {
  background-color: #d9534f;
  border: 1px solid #d43f3a;
}

.status-scheduled {
  background-color: #f0ad4e;
  border: 1px solid #eea236;
}

/* Appointment List Styling */
.appointment-row {
  display: grid; /* Utilisation de Grid */
  /* Définition des colonnes: Patient(1fr), Type(auto), Statuts(auto), Actions(auto) */
  grid-template-columns: 1fr auto auto auto; /* <<< MODIFIÉ: 4 colonnes */
  gap: 15px; /* Espace entre les colonnes */
  align-items: center;
  margin-bottom: 10px;
  background-color: #fff;
  border-radius: 5px;
  box-shadow: 0 1px 3px rgba(0,0,0,0.1);
  padding: 10px 15px;
  transition: transform 0.2s, box-shadow 0.2s; /* Ajouter une transition pour la fluidité */
}

.appointment-row:hover {
  transform: translateY(-3px); /* Légère élévation (ajusté pour être moins prononcé que les cartes) */
  box-shadow: 0 4px 10px rgba(0, 0, 0, 0.12); /* Ombre légèrement plus prononcée */
}

.appointment-cell {
  display: flex; /* Garder flex pour l'alignement interne des éléments de la cellule si nécessaire */
  align-items: center;
  /* padding: 5px; Retiré car le gap de Grid gère l'espacement */
  overflow: hidden; /* Empêcher le dépassement si le contenu est trop long */
  text-overflow: ellipsis; /* Ajouter '...' si le texte dépasse */
  /* white-space: nowrap; Supprimé ici, sera géré spécifiquement */
}

.appointment-cell.patient-info {
  /* Appliquer Flexbox en colonne */
  display: flex;
  flex-direction: column;
  align-items: flex-start; /* Aligner le contenu à gauche */
  justify-content: center; /* Centrer verticalement le bloc nom/contact */
  font-weight: normal; /* Le nom aura son propre style */
  white-space: normal; /* Permettre le retour à la ligne pour les noms/contacts */
  /* Retrait des anciennes propriétés flex/min-width si présentes */
  gap: 0.1rem; /* Petit espace entre nom et contacts */
}

.patient-name {
  font-weight: 600; /* Mettre le nom en gras */
  font-size: 0.95rem; /* Taille légèrement plus grande si besoin */
  color: #333;
  margin-bottom: 2px; /* Espace après le nom */
}

.patient-datetime-info {
  font-size: 0.85rem; /* Taille légèrement plus petite */
  color: #777; /* Couleur discrète */
  margin-top: 2px; /* Petit espace après le nom */
  margin-bottom: 4px; /* Espace avant les contacts (si présents) */
  white-space: normal; /* Permettre le retour à la ligne si nécessaire */
}

.patient-datetime-info .time-separator {
  /* Style spécifique pour le 'à' si besoin */
  margin: 0 2px;
}

.patient-contact-details {
  display: flex;
  flex-direction: column; /* Empiler email/téléphone */
  align-items: flex-start;
  font-size: 0.8rem; /* Taille plus petite pour les contacts */
  color: #666; /* Couleur plus discrète */
}

.patient-contact-details span {
  /* Style pour chaque info de contact si besoin */
  line-height: 1.3;
}

.appointment-cell.type-info {
  /* flex: 1.5; Supprimé */
  /* min-width: 100px; Supprimé */
  color: #777;
  font-style: italic;
}

/* La cellule contenant les badges */
.appointment-cell.communication-status-badges {
   /* Pas besoin de flex ou min-width ici, la colonne grid est 'auto' */
   justify-content: center; /* Centrer les badges à l'intérieur de la cellule si elle est plus large */
}

.appointment-cell.action-cell {
  /* flex: 0 0 auto; Supprimé */
  /* min-width: 70px; Supprimé */
  justify-content: flex-end; /* Align button to the right within its cell */
}

.appointment-cell.action-cell .btn-sm {
  margin-left: 0.5rem;
  font-weight: 400;
}

/* Styles pour les badges de statut de communication */
.communication-status-badges { 
  /* Les styles internes restent les mêmes (flex, gap, etc.) */
  display: flex;
  flex-direction: row; 
  gap: 0.5rem; 
}

.comm-badge-button { 
  /* Retrait de min-width pour laisser le badge s'adapter */
  /* min-width: 100px; */ 
  display: inline-block;
  padding: 0.25rem 0.6rem; 
  font-size: 0.75rem; 
  font-weight: 500;
  border-radius: 4px; /* Coins légèrement arrondis */
  border: 1px solid transparent; /* Bordure initiale */
  text-align: center;
  white-space: nowrap; /* Empêche le retour à la ligne */
  color: #fff; /* Couleur de texte par défaut (blanc) */
}

/* Les classes de couleur s'appliquent maintenant à .comm-badge-button */
.pastille-success {
  background-color: #28a745; /* Vert */
  border-color: #218838;
  color: #fff;
}

.pastille-error {
  background-color: #dc3545; /* Rouge */
  border-color: #c82333;
  color: #fff;
}

.pastille-warning {
  background-color: #ffc107; /* Jaune/Orange */
  border-color: #e0a800;
  color: #212529; /* Texte foncé pour contraste sur jaune */
}

.pastille-neutral {
  background-color: #e2e3e5; /* Gris clair */
  border-color: #d6d8db;
  color: #383d41; /* Texte foncé pour contraste sur gris clair */
}
`, "",{"version":3,"sources":["webpack://./src/App.css"],"names":[],"mappings":"AAAA;EACE,sBAAsB;EACtB,SAAS;EACT,UAAU;AACZ;;AAEA;EACE,4DAA4D;EAC5D,gBAAgB;EAChB,WAAW;EACX,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,iBAAiB;AACnB;;AAEA;EACE,SAAO;EACP,yBAAyB;AAC3B;;AAEA;EACE,qBAAqB;EACrB,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,oBAAoB;AACtB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,qBAAqB;EACrB,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,iBAAiB;EACjB,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,mBAAmB;AACrB;;AAEA,qCAAqC;AACrC;EACE,qBAAqB;EACrB,wBAAwB;EACxB,mBAAmB;EACnB,mBAAmB;EACnB,gBAAgB;EAChB,kBAAkB;EAClB,mBAAmB;EACnB,WAAW;EACX,oBAAoB;EACpB,wCAAwC;AAC1C;;AAEA,4BAA4B;AAC5B;EACE,yBAAyB;EACzB,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,yBAAyB;AAC3B;;AAEA,+BAA+B;AAC/B;EACE,sBAAsB;EACtB,sBAAsB;AACxB;;AAEA;EACE,yBAAyB;EACzB,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,yBAAyB;AAC3B;;AAEA,6BAA6B;AAC7B;EACE,aAAa,EAAE,wBAAwB;EACvC,oFAAoF;EACpF,yCAAyC,EAAE,4BAA4B;EACvE,SAAS,EAAE,8BAA8B;EACzC,mBAAmB;EACnB,mBAAmB;EACnB,sBAAsB;EACtB,kBAAkB;EAClB,qCAAqC;EACrC,kBAAkB;EAClB,2CAA2C,EAAE,4CAA4C;AAC3F;;AAEA;EACE,2BAA2B,EAAE,sEAAsE;EACnG,0CAA0C,EAAE,oCAAoC;AAClF;;AAEA;EACE,aAAa,EAAE,mFAAmF;EAClG,mBAAmB;EACnB,8DAA8D;EAC9D,gBAAgB,EAAE,wDAAwD;EAC1E,uBAAuB,EAAE,sCAAsC;EAC/D,gEAAgE;AAClE;;AAEA;EACE,iCAAiC;EACjC,aAAa;EACb,sBAAsB;EACtB,uBAAuB,EAAE,gCAAgC;EACzD,uBAAuB,EAAE,8CAA8C;EACvE,mBAAmB,EAAE,iCAAiC;EACtD,mBAAmB,EAAE,0DAA0D;EAC/E,iEAAiE;EACjE,WAAW,EAAE,uCAAuC;AACtD;;AAEA;EACE,gBAAgB,EAAE,0BAA0B;EAC5C,kBAAkB,EAAE,4CAA4C;EAChE,WAAW;EACX,kBAAkB,EAAE,wBAAwB;AAC9C;;AAEA;EACE,kBAAkB,EAAE,kCAAkC;EACtD,WAAW,EAAE,qBAAqB;EAClC,eAAe,EAAE,8BAA8B;EAC/C,kBAAkB,EAAE,4CAA4C;EAChE,mBAAmB,EAAE,iDAAiD;AACxE;;AAEA;EACE,2CAA2C;EAC3C,aAAa;AACf;;AAEA;EACE,aAAa;EACb,sBAAsB,EAAE,4BAA4B;EACpD,uBAAuB;EACvB,iBAAiB,EAAE,yCAAyC;EAC5D,WAAW,EAAE,0BAA0B;AACzC;;AAEA;EACE,gDAAgD;EAChD,gBAAgB;AAClB;;AAEA;EACE,wBAAwB;EACxB,+BAA+B;EAC/B,WAAW;EACX,kBAAkB;AACpB;;AAEA,oCAAoC;AACpC;GACG,oEAAoE;GACpE,uBAAuB,EAAE,0EAA0E;AACtG;;AAEA;EACE,6BAA6B;EAC7B,8BAA8B;EAC9B,yBAAyB,EAAE,8CAA8C;AAC3E;;AAEA;EACE,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA,sDAAsD;AACtD;EACE,4DAA4D;EAC5D,aAAa;EACb,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,yDAAyD;EACzD,sBAAsB;EACtB,qBAAqB;EACrB,uBAAuB;EACvB,kBAAkB;EAClB,gBAAgB;EAChB,kBAAkB,EAAE,8BAA8B;EAClD,6BAA6B,EAAE,qBAAqB;EACpD,kBAAkB;EAClB,mBAAmB,EAAE,iCAAiC;EACtD,WAAW,EAAE,wCAAwC;AACvD;;AAEA,wEAAwE;AACxE;EACE,yBAAyB,EAAE,SAAS;EACpC,qBAAqB;EACrB,WAAW;AACb;;AAEA;EACE,yBAAyB,EAAE,UAAU;EACrC,qBAAqB;EACrB,WAAW;AACb;;AAEA;EACE,yBAAyB,EAAE,iBAAiB;EAC5C,qBAAqB;EACrB,cAAc,EAAE,yCAAyC;AAC3D;;AAEA;EACE,yBAAyB,EAAE,eAAe;EAC1C,qBAAqB;EACrB,cAAc,EAAE,8CAA8C;AAChE","sourcesContent":["* {\n  box-sizing: border-box;\n  margin: 0;\n  padding: 0;\n}\n\nbody {\n  font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;\n  line-height: 1.6;\n  color: #333;\n  background-color: #f5f5f5;\n}\n\n.App {\n  display: flex;\n  flex-direction: column;\n  min-height: 100vh;\n}\n\n.App-main {\n  flex: 1;\n  background-color: #f5f5f5;\n}\n\na {\n  text-decoration: none;\n  color: inherit;\n}\n\nbutton {\n  cursor: pointer;\n  font-family: inherit;\n}\n\ninput, select, textarea {\n  font-family: inherit;\n}\n\nh1, h2, h3, h4, h5, h6 {\n  margin-bottom: 0.5rem;\n  font-weight: 500;\n  line-height: 1.2;\n}\n\nh1 {\n  font-size: 2rem;\n}\n\nh2 {\n  font-size: 1.75rem;\n}\n\nh3 {\n  font-size: 1.5rem;\n}\n\nh4 {\n  font-size: 1.25rem;\n}\n\nh5 {\n  font-size: 1rem;\n}\n\nh6 {\n  font-size: 0.875rem;\n}\n\np {\n  margin-bottom: 1rem;\n}\n\n.container {\n  width: 100%;\n  max-width: 1200px;\n  margin: 0 auto;\n  padding: 0 1rem;\n}\n\n.text-center {\n  text-align: center;\n}\n\n.mt-1 {\n  margin-top: 0.25rem;\n}\n\n.mt-2 {\n  margin-top: 0.5rem;\n}\n\n.mt-3 {\n  margin-top: 1rem;\n}\n\n.mt-4 {\n  margin-top: 1.5rem;\n}\n\n.mt-5 {\n  margin-top: 2rem;\n}\n\n.mb-1 {\n  margin-bottom: 0.25rem;\n}\n\n.mb-2 {\n  margin-bottom: 0.5rem;\n}\n\n.mb-3 {\n  margin-bottom: 1rem;\n}\n\n.mb-4 {\n  margin-bottom: 1.5rem;\n}\n\n.mb-5 {\n  margin-bottom: 2rem;\n}\n\n/* Styles pour les badges de statut */\n.status-badge {\n  display: inline-block;\n  padding: 0.35rem 0.75rem;\n  border-radius: 1rem;\n  font-size: 0.875rem;\n  font-weight: 500;\n  text-align: center;\n  white-space: nowrap;\n  color: #fff;\n  margin-right: 0.5rem;\n  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);\n}\n\n/* Statuts des rendez-vous */\n.status-pending {\n  background-color: #f0ad4e;\n  border: 1px solid #eea236;\n}\n\n.status-confirmed {\n  background-color: #5bc0de;\n  border: 1px solid #46b8da;\n}\n\n.status-completed {\n  background-color: #5cb85c;\n  border: 1px solid #4cae4c;\n}\n\n.status-cancelled {\n  background-color: #d9534f;\n  border: 1px solid #d43f3a;\n}\n\n/* Statuts des communications */\n.status-not-sent {\n  background-color: #777;\n  border: 1px solid #666;\n}\n\n.status-sending {\n  background-color: #f0ad4e;\n  border: 1px solid #eea236;\n}\n\n.status-sent {\n  background-color: #5bc0de;\n  border: 1px solid #46b8da;\n}\n\n.status-delivered {\n  background-color: #5cb85c;\n  border: 1px solid #4cae4c;\n}\n\n.status-failed {\n  background-color: #d9534f;\n  border: 1px solid #d43f3a;\n}\n\n.status-opened, .status-clicked {\n  background-color: #5cb85c;\n  border: 1px solid #4cae4c;\n}\n\n.status-bounced {\n  background-color: #d9534f;\n  border: 1px solid #d43f3a;\n}\n\n.status-scheduled {\n  background-color: #f0ad4e;\n  border: 1px solid #eea236;\n}\n\n/* Appointment List Styling */\n.appointment-row {\n  display: grid; /* Utilisation de Grid */\n  /* Définition des colonnes: Patient(1fr), Type(auto), Statuts(auto), Actions(auto) */\n  grid-template-columns: 1fr auto auto auto; /* <<< MODIFIÉ: 4 colonnes */\n  gap: 15px; /* Espace entre les colonnes */\n  align-items: center;\n  margin-bottom: 10px;\n  background-color: #fff;\n  border-radius: 5px;\n  box-shadow: 0 1px 3px rgba(0,0,0,0.1);\n  padding: 10px 15px;\n  transition: transform 0.2s, box-shadow 0.2s; /* Ajouter une transition pour la fluidité */\n}\n\n.appointment-row:hover {\n  transform: translateY(-3px); /* Légère élévation (ajusté pour être moins prononcé que les cartes) */\n  box-shadow: 0 4px 10px rgba(0, 0, 0, 0.12); /* Ombre légèrement plus prononcée */\n}\n\n.appointment-cell {\n  display: flex; /* Garder flex pour l'alignement interne des éléments de la cellule si nécessaire */\n  align-items: center;\n  /* padding: 5px; Retiré car le gap de Grid gère l'espacement */\n  overflow: hidden; /* Empêcher le dépassement si le contenu est trop long */\n  text-overflow: ellipsis; /* Ajouter '...' si le texte dépasse */\n  /* white-space: nowrap; Supprimé ici, sera géré spécifiquement */\n}\n\n.appointment-cell.patient-info {\n  /* Appliquer Flexbox en colonne */\n  display: flex;\n  flex-direction: column;\n  align-items: flex-start; /* Aligner le contenu à gauche */\n  justify-content: center; /* Centrer verticalement le bloc nom/contact */\n  font-weight: normal; /* Le nom aura son propre style */\n  white-space: normal; /* Permettre le retour à la ligne pour les noms/contacts */\n  /* Retrait des anciennes propriétés flex/min-width si présentes */\n  gap: 0.1rem; /* Petit espace entre nom et contacts */\n}\n\n.patient-name {\n  font-weight: 600; /* Mettre le nom en gras */\n  font-size: 0.95rem; /* Taille légèrement plus grande si besoin */\n  color: #333;\n  margin-bottom: 2px; /* Espace après le nom */\n}\n\n.patient-datetime-info {\n  font-size: 0.85rem; /* Taille légèrement plus petite */\n  color: #777; /* Couleur discrète */\n  margin-top: 2px; /* Petit espace après le nom */\n  margin-bottom: 4px; /* Espace avant les contacts (si présents) */\n  white-space: normal; /* Permettre le retour à la ligne si nécessaire */\n}\n\n.patient-datetime-info .time-separator {\n  /* Style spécifique pour le 'à' si besoin */\n  margin: 0 2px;\n}\n\n.patient-contact-details {\n  display: flex;\n  flex-direction: column; /* Empiler email/téléphone */\n  align-items: flex-start;\n  font-size: 0.8rem; /* Taille plus petite pour les contacts */\n  color: #666; /* Couleur plus discrète */\n}\n\n.patient-contact-details span {\n  /* Style pour chaque info de contact si besoin */\n  line-height: 1.3;\n}\n\n.appointment-cell.type-info {\n  /* flex: 1.5; Supprimé */\n  /* min-width: 100px; Supprimé */\n  color: #777;\n  font-style: italic;\n}\n\n/* La cellule contenant les badges */\n.appointment-cell.communication-status-badges {\n   /* Pas besoin de flex ou min-width ici, la colonne grid est 'auto' */\n   justify-content: center; /* Centrer les badges à l'intérieur de la cellule si elle est plus large */\n}\n\n.appointment-cell.action-cell {\n  /* flex: 0 0 auto; Supprimé */\n  /* min-width: 70px; Supprimé */\n  justify-content: flex-end; /* Align button to the right within its cell */\n}\n\n.appointment-cell.action-cell .btn-sm {\n  margin-left: 0.5rem;\n  font-weight: 400;\n}\n\n/* Styles pour les badges de statut de communication */\n.communication-status-badges { \n  /* Les styles internes restent les mêmes (flex, gap, etc.) */\n  display: flex;\n  flex-direction: row; \n  gap: 0.5rem; \n}\n\n.comm-badge-button { \n  /* Retrait de min-width pour laisser le badge s'adapter */\n  /* min-width: 100px; */ \n  display: inline-block;\n  padding: 0.25rem 0.6rem; \n  font-size: 0.75rem; \n  font-weight: 500;\n  border-radius: 4px; /* Coins légèrement arrondis */\n  border: 1px solid transparent; /* Bordure initiale */\n  text-align: center;\n  white-space: nowrap; /* Empêche le retour à la ligne */\n  color: #fff; /* Couleur de texte par défaut (blanc) */\n}\n\n/* Les classes de couleur s'appliquent maintenant à .comm-badge-button */\n.pastille-success {\n  background-color: #28a745; /* Vert */\n  border-color: #218838;\n  color: #fff;\n}\n\n.pastille-error {\n  background-color: #dc3545; /* Rouge */\n  border-color: #c82333;\n  color: #fff;\n}\n\n.pastille-warning {\n  background-color: #ffc107; /* Jaune/Orange */\n  border-color: #e0a800;\n  color: #212529; /* Texte foncé pour contraste sur jaune */\n}\n\n.pastille-neutral {\n  background-color: #e2e3e5; /* Gris clair */\n  border-color: #d6d8db;\n  color: #383d41; /* Texte foncé pour contraste sur gris clair */\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
